import React from "react";

export const LandingOverlay: React.FC<{ onContinueAnon: () => void }> = ({ onContinueAnon }) => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "#1e1e2e",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 99999,
      gap: 12,
    }}
  >
    <div style={{ marginBottom: 16, textAlign: "center" }}>
      <div style={{ fontSize: 28, fontWeight: 700, color: "#cdd6f4", letterSpacing: "-0.5px" }}>
        Syntrofi Draw
      </div>
      <div style={{ fontSize: 14, color: "#6c7086", marginTop: 6 }}>
        Collaborative whiteboard for your team
      </div>
    </div>

    <a
      href="/auth/login"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "12px 24px",
        background: "#cdd6f4",
        color: "#1e1e2e",
        borderRadius: 10,
        fontSize: 15,
        fontWeight: 600,
        textDecoration: "none",
        width: 260,
        justifyContent: "center",
      }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0 1 12 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/>
      </svg>
      Login with GitHub
    </a>

    <button
      onClick={onContinueAnon}
      style={{
        background: "none",
        border: "1px solid #313244",
        borderRadius: 10,
        color: "#6c7086",
        fontSize: 14,
        padding: "11px 24px",
        cursor: "pointer",
        width: 260,
      }}
    >
      Continue without account
    </button>
  </div>
);
